import { BigNumber } from 'bignumber.js';

export function transformPercentInput(value: number | null): string {
    if (!value) return '';
    return BigNumber(value).multipliedBy(100).toString();
}
